














































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class SectionVerMati extends Vue {
  @Prop() form!: any;

  golDarahOptions = ["A", "B", "AB", "O", "Tidak diperiksa"];

  kepalaFields = [
    { key: "rambut", label: "a. Rambut", hint: "Warna, panjang, distribusi, kebersihan..." },
    { key: "bawah_rambut", label: "b. Bagian Tertutup Rambut", hint: "Kulit kepala, hematom, luka..." },
    { key: "dahi", label: "c. Dahi", hint: "Luka, memar, bengkak..." },
    { key: "mata_kanan", label: "d. Mata Kanan", hint: "Kelopak, konjungtiva, kornea, pupil (ukuran, refleks), petechiae..." },
    { key: "mata_kiri", label: "d. Mata Kiri", hint: "Kelopak, konjungtiva, kornea, pupil (ukuran, refleks), petechiae..." },
    { key: "hidung", label: "e. Hidung", hint: "Bentuk, septum, sekret, patah tulang..." },
    { key: "mulut", label: "f. Mulut", hint: "Bibir, lidah, gigi, mukosa, benda asing..." },
    { key: "dagu", label: "g. Dagu", hint: "Luka, memar..." },
    { key: "pipi", label: "h. Pipi", hint: "Luka, memar, bengkak..." },
    { key: "telinga", label: "i. Telinga", hint: "Daun telinga, liang telinga, sekret, perdarahan..." },
  ];

  regioLuarList = [
    { num: 8, field: "pl_leher", label: "Leher", hint: "Bekas cekikan, jejas, deformitas..." },
    { num: 9, field: "pl_dada", label: "Dada", hint: "Bentuk, simetris, jejas, luka..." },
    { num: 10, field: "pl_perut", label: "Perut", hint: "Datar/cembung, jejas, luka..." },
    { num: 11, field: "pl_alat_kelamin", label: "Alat Kelamin", hint: "Luka, robekan, perdarahan..." },
  ];

  regioLuar2List = [
    { num: 13, field: "pl_punggung", label: "Punggung", hint: "" },
    { num: 14, field: "pl_pantat", label: "Pantat", hint: "" },
    { num: 15, field: "pl_dubur", label: "Dubur", hint: "" },
  ];

  organList = [
    {
      num: 1, field: "pd_kulit_dada", label: "Setelah Kulit Dada Dibuka",
      hint: "Jaringan lemak subkutan, otot dada...",
      children: null,
    },
    {
      num: 2, field: "pd_rongga_dada", label: "Rongga Dada",
      hint: "Cairan, perlengketan...",
      children: [
        { field: "pd_jantung", label: "a. Jantung", hint: "Ukuran, berat, perikardium, katup, otot jantung..." },
        { field: "pd_paru_kanan", label: "b. Paru-paru Kanan", hint: "Ukuran, berat, permukaan, konsistensi..." },
        { field: "pd_paru_kiri", label: "b. Paru-paru Kiri", hint: "Ukuran, berat, permukaan, konsistensi..." },
      ],
    },
    {
      num: 3, field: "pd_rongga_perut", label: "Setelah Kulit dan Dinding Perut Dibuka",
      hint: "Cairan, perlengketan, organ in situ...",
      children: [
        { field: "pd_hati", label: "b. Hati", hint: "Ukuran, berat, permukaan, konsistensi..." },
        { field: "pd_limpa", label: "c. Limpa", hint: "Ukuran, berat, konsistensi..." },
        { field: "pd_ginjal_kanan", label: "d. Ginjal Kanan", hint: "Ukuran, berat, kapsul, korteks..." },
        { field: "pd_ginjal_kiri", label: "d. Ginjal Kiri", hint: "Ukuran, berat, kapsul, korteks..." },
        { field: "pd_lambung", label: "e. Lambung", hint: "Isi, mukosa, ulkus..." },
        { field: "pd_usus", label: "f. Usus", hint: "Isi, mukosa, patensi..." },
      ],
    },
    {
      num: 4, field: "pd_leher", label: "Leher (Pemeriksaan Dalam)",
      hint: "Otot leher, kartilago laring, tulang hyoid, trakea...",
      children: null,
    },
    {
      num: 5, field: "pd_kepala", label: "Kepala (Pemeriksaan Dalam)",
      hint: "Kulit kepala bagian dalam, tengkorak, meninges...",
      children: [
        { field: "pd_otak", label: "Otak", hint: "Serebrum, serebelum, batang otak, berat, edema, perdarahan..." },
      ],
    },
  ];

  addHisto() {
    if (!this.form.lab_histopatologi) {
      this.$set(this.form, "lab_histopatologi", []);
    }
    this.form.lab_histopatologi.push({ kode: "", jaringan: "", hasil: "" });
  }

  removeHisto(idx) {
    this.form.lab_histopatologi.splice(idx, 1);
  }
}
